import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, BodyText, Box, MaterialSymbol, withStyles } from 'vopay';
import { Title, Button } from 'UI';
import styles from './BlockingDialog.module.scss';
import unBlockSubAccountIcon from './icons/unBlockSubAccount.svg';

const cn = withStyles(styles);

export type UnBlockAccountDialogProps = {
  accountName: string;
  onConfirm: (val: true) => void;
  onCancel: () => void;
};

const UnBlockAccountDialog: FunctionComponent<UnBlockAccountDialogProps> = ({ accountName, onConfirm, onCancel }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.UnblockAccountDialog' });

  return (
    <Card className={cn('dialogueCard')}>
      <div className={cn('icon')}>
        <img src={unBlockSubAccountIcon} alt="Unblock Sub-Account" width="80" height="80" />
      </div>

      <div className={cn('title')}>
        <Title level="3">{t('title', { defaultValue: 'Unblock Sub-Account' })}</Title>
      </div>

      <BodyText className={cn('bodyText')}>
        <div className={cn('description')}>
          {t('description', { defaultValue: 'Unblocking the Sub-Account will enable:' })}
        </div>
        <ul className={cn('bulletList')}>
          <li>{t('resumeOutbound', { defaultValue: 'Outbound transactions from the sub-account will resume.' })}</li>
          <li>
            {t('depositInbound', {
              defaultValue:
                'Inbound transactions will deposit to the respective sub-account instead of the parent account.',
            })}
          </li>
        </ul>
      </BodyText>

      <Box className={cn('infoBox')}>
        <MaterialSymbol icon="lan" fillAmount={1} size="20px" color="#2F82FFBF" className={cn('infoIcon')} />
        <BodyText className={cn('bodyText')} size="rg">
          {t('impactMessage', { accountName, defaultValue: 'This will impact {{accountName}} only.' })}
        </BodyText>
      </Box>

      <div className={cn('buttonContainer')}>
        <Button onClick={onCancel}>{t('cancelButton', { defaultValue: 'Cancel' })}</Button>
        <Button colorScheme="primary" onClick={() => onConfirm(true)}>
          {t('confirmButton', { defaultValue: 'Confirm & Unblock' })}
        </Button>
      </div>
    </Card>
  );
};

export default UnBlockAccountDialog;
